import { resolveInvoiceStatus } from "./invoices";
import { getOutstandingBalance } from "./accountsReceivable";
import { formatCurrency } from "./estimateTotals";

/**
 * Desktop Invoice Hub dashboard metrics derived from the already-loaded
 * invoice list — no extra queries, no new widgets.
 */

export function countInvoicesByStatus(invoices = []) {
  const counts = {
    draft: 0,
    sent: 0,
    paid: 0,
    archived: 0,
  };

  for (const invoice of invoices) {
    const status = resolveInvoiceStatus(invoice?.status);
    if (Object.prototype.hasOwnProperty.call(counts, status)) {
      counts[status] += 1;
    }
  }

  return counts;
}

export function buildInvoiceHubStatusMetrics(
  invoices = [],
  { onSelectStatus } = {},
) {
  const counts = countInvoicesByStatus(invoices);

  return [
    {
      key: "draft",
      label: "Draft Invoices",
      value: counts.draft,
      onClick: onSelectStatus ? () => onSelectStatus("draft") : undefined,
    },
    {
      key: "sent",
      label: "Sent Invoices",
      value: counts.sent,
      onClick: onSelectStatus ? () => onSelectStatus("sent") : undefined,
    },
    {
      key: "paid",
      label: "Paid Invoices",
      value: counts.paid,
      onClick: onSelectStatus ? () => onSelectStatus("paid") : undefined,
    },
    {
      key: "archived",
      label: "Archived",
      value: counts.archived,
      onClick: onSelectStatus ? () => onSelectStatus("archived") : undefined,
    },
  ];
}

export function buildInvoiceHubFinancialMetrics(invoices = []) {
  let draftValue = 0;
  let outstandingBalance = 0;
  let paidTotal = 0;

  for (const invoice of invoices) {
    const amount = Number(invoice?.total_amount || 0);
    const status = resolveInvoiceStatus(invoice?.status);

    if (status === "draft") {
      draftValue += amount;
    } else if (status === "sent") {
      outstandingBalance += getOutstandingBalance(invoice);
    } else if (status === "paid") {
      paidTotal += amount;
    }
  }

  return [
    {
      key: "draft_value",
      label: "Draft Value",
      value: formatCurrency(draftValue),
    },
    {
      key: "outstanding",
      label: "Outstanding Balance",
      value: formatCurrency(outstandingBalance),
    },
    {
      key: "paid_total",
      label: "Paid Total",
      value: formatCurrency(paidTotal),
    },
    {
      key: "invoice_count",
      label: "Total Invoices",
      value: invoices.length,
    },
  ];
}

export function buildInvoiceHubRecentMetrics(
  invoices = [],
  { onOpen, limit = 5 } = {},
) {
  return [...(invoices || [])]
    .sort((left, right) => {
      const leftAt = Date.parse(left?.updated_at || left?.created_at || 0);
      const rightAt = Date.parse(right?.updated_at || right?.created_at || 0);
      return rightAt - leftAt;
    })
    .slice(0, limit)
    .map((invoice) => ({
      key: invoice.invoice_id,
      label: invoice.invoice_number || "Invoice",
      subtitle: invoice.clients?.client_name || invoice.title || undefined,
      value: formatCurrency(Number(invoice.total_amount || 0)),
      onClick: onOpen ? () => onOpen(invoice) : undefined,
    }));
}
